// extracted by mini-css-extract-plugin
module.exports = {"logo":"roomList_logo__3RQjc","item":"roomList_item__2w1li","name":"roomList_name__21KYb"};